/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P2_DInputs */

const en_mk_sec_pg_p2_d = /** @type {(inputs: Mk_Sec_Pg_P2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent’s permissions are always judged against the person who set it going. It cannot see anything that person may not see.`)
};

const id_mk_sec_pg_p2_d = /** @type {(inputs: Mk_Sec_Pg_P2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izin agen selalu dinilai dari manusia yang menyuruhnya. Agen tidak bisa melihat apa pun yang tidak boleh dilihat orang itu.`)
};

/**
* | output |
* | --- |
* | "An agent’s permissions are always judged against the person who set it going. It cannot see anything that person may not see." |
*
* @param {Mk_Sec_Pg_P2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p2_d = /** @type {((inputs?: Mk_Sec_Pg_P2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p2_d(inputs)
	return en_mk_sec_pg_p2_d(inputs)
});